import {
  BankSecretRow,
  ClientInfo,
  ClientListResponse,
  ClientSecret,
  Transaction,
} from "@/types";
import { ClientState } from "./index";

export default {
  setClientList(state: ClientState, payload: ClientListResponse) {
    state.clientList = payload.clientList;
    state.total = payload.total;
  },
  setUserList(state: ClientState, payload: ClientState["userList"]) {
    state.userList = payload;
  },
  setCurrentClient(state: ClientState, payload: ClientInfo) {
    state.currentClient = payload;
  },
  setCurrentIntegration(state: ClientState, payload: ClientSecret) {
    state.currentIntegration = payload;
  },
  setTransactions(state: ClientState, payload: Transaction[]) {
    state.transactions = payload;
  },
  setIntegrations(state: ClientState, payload: BankSecretRow[]) {
    state.integrations = payload;
  },
  setCurrentTab(state: ClientState, payload: string) {
    state.currentTab = payload;
  },
  setSearchConfig(state: ClientState, payload: ClientState["searchConfig"]) {
    state.searchConfig = payload;
  },
  setFilterConfig(state: ClientState, payload: ClientState["filterConfig"]) {
    state.filterConfig = payload;
  },
  toggleFilter(state: ClientState) {
    state.filterConfig.isActive = !state.filterConfig.isActive;
  },
  setPage(state: ClientState, page: number) {
    state.page = page;
  },
};
